import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { HelperService } from 'src/app/shared/utils/helper.service';
import { NotificationService } from 'src/app/shared/errors/notification.service';
import { ConfirmRemoveDialogComponent } from 'src/app/shared-layout/Components/confirm-remove-dialog/confirm-remove-dialog.component';
import { UserLoginService } from 'src/app/shared/services/user-login.service';
import { LoaderService } from 'src/app/shared/utils/loader.service';
import { StateManagementService } from 'src/app/shared/services/state-management.service';
import { ActivatedRoute, Router } from '@angular/router';
import LoginRoutingPath from 'src/app/login/login-routing-path';
import {
  FilterUserParameter,
  IAccessDetail,
  ICriteria,
  IUser,
  IUserProfile,
} from 'src/app/user-management/user-management-interfaces';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { Subject, Subscription, of } from 'rxjs';
import { debounceTime, switchMap } from 'rxjs/operators';
import { PhoneNumberFormatPipe } from 'src/app/libs/ui/pipes/phone-number-format/phone-number-format.pipe';
import { AccountSettingsService } from 'src/app/shared-layout/header/account-settings/account-setting.service';
import { UserManagementService } from 'src/app/user-management/user-management.service';
import { CommonService } from 'src/app/shared/utils/common.service';
import { PhysicalCredentialRemovedComponent } from 'src/app/shared-layout/Components/physical-credential-removed/physical-credential-removed.component';
import { SharedDataService } from 'src/app/shared/services/shared-data.service';
import { Utility } from 'src/app/shared/utils/utility.service';
import { DashboardManagementService } from 'src/app/dashboard/dashboard-management.service';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { TranslateService } from '@ngx-translate/core';
const ACTIVE = 'ACTIVE';
@Component({
  selector: 'app-user-profile-details',
  templateUrl: './user-profile-details.component.html',
  styleUrls: ['./user-profile-details.component.scss'],
})
export class UserProfileDetailsComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Input() profileDetails!: IUserProfile;
  @Input() ownProfile!: boolean;
  @Input() sharedData: any;
  @Input() groupTypeName!: string;
  @Input() userGroupId!: string;
  @Output() stepperChange = new EventEmitter<number>();
  @Input() profileImageSrc: string = 'assets/images/portrait-happy.jpg';
  @Input() flowType!: string;
  @Output() flowTypeChange = new EventEmitter<string>();
  @Input() userNotHaveExistingGroup!: boolean;
  siteId!: string;
  CONSTANTS = CONSTANTS;
  userId!: string;
  private mobileCredentialClicked = new Subject<boolean | undefined>();
  private cardCredentialClicked = new Subject<boolean | undefined>();
  getNotExpiredTempRecords!: IAccessDetail[];
  pageSize = 40;
  formGroup!: FormGroup;
  submited = false;
  readonly LANG_CONST = LANG_CONST;
  subscription: Subscription | undefined;
  userListsubscription: Subscription | undefined;
  dashboardUserListSubscription: Subscription | undefined;
  filterUserParam: FilterUserParameter[] | undefined;
  searchedWord!: string;
  loginUser!: IUser;
  FORM_ICONS = {
    USER_TYPE: 'assets/svg/ico-user.svg',
    USER_ACCESS: 'assets/svg/ico-lock.svg',
    USER_ACTIVITY: 'assets/svg/ico-user-activity-gray.svg',
    USER_GROUP: 'assets/svg/ico-group.svg',
    PHYSICAL_CREDENTIALS: 'assets/svg/ico-guestaccess.svg',
  };
  isUserCardActive: any;
  userCredentials: any;
  commonAccessControl!: boolean;

  get formInstance() {
    return this.formGroup.controls;
  }

  get formattedAutoDeactivationDate(): string {
    if (!this.profileDetails?.autoDeactivationDate) return '';
    const date = new Date(
      this.profileDetails.autoDeactivationDate.replace(/\//g, '-')
    );
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  }
  constructor(
    private el: ElementRef,
    private rootFormGroup: FormGroupDirective,
    private helperService: HelperService,
    private notificationService: NotificationService,
    private accountSettingService: AccountSettingsService,
    private router: Router,
    private phoneNumberFormat: PhoneNumberFormatPipe,
    private userManagementService: UserManagementService,
    public stateManagementService: StateManagementService,
    private route: ActivatedRoute,
    private sharedDataService: SharedDataService,
    private dashboardManagementService: DashboardManagementService,
    private commonService: CommonService,
    private localizationService: LocalizationService,
    private translate: TranslateService
  ) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.loginUser = this.stateManagementService.getUser();
    this.localizationService.setupLocalization();
    this.commonService.userGroupId$.subscribe((userGroupId) => {
      this.userGroupId = userGroupId;
    });

    this.filterUserParam = this.sharedDataService.filterUser;
    this.searchedWord = this.sharedDataService.searchFilterUserWord;

    this.commonAccessControl =
      this.stateManagementService.getSharedData()?.selectedSite?.commonAccessControl;
    this.siteId = this.sharedData?.selectedSite?.siteId;
    // setting username property
    if (this.profileDetails?.firstName && this.profileDetails?.lastName) {
      this.profileDetails.name = `${this.profileDetails?.firstName} ${this.profileDetails?.lastName}`;
    }
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;

    const mobileCredentialClickedDebounced = this.mobileCredentialClicked.pipe(
      debounceTime(500)
    );
    mobileCredentialClickedDebounced.subscribe(
      (status: boolean | undefined) => {
        // The actual action that should be performed on click
        this.updateMobileCardCredentials(
          status!,
          this.formInstance?.cardCredential?.value
        );
      }
    );

    const cardCredentialClickedDebounced = this.cardCredentialClicked.pipe(
      debounceTime(500)
    );
    cardCredentialClickedDebounced.subscribe((status: boolean | undefined) => {
      // The actual action that should be performed on click
      this.updateMobileCardCredentials(
        this.formInstance?.mobileCredential?.value,
        status!
      );
    });
    this.userId = this.formInstance?.email?.value;
    this.getNotExpiredTempRecords = this.expiryCheckWithCurrentUTC(
      this.profileDetails?.userAccess?.temporaryAccess
    );
    this.getPhysicalCredential();
  }

  ngAfterViewInit(): void {
    // Angular Material v12's dialog FocusTrap fires after the 150ms enter animation.
    // Without a delay, scrollTop=0 runs before autofocus scrolls the container down.
    setTimeout(() => {
      const host = this.el.nativeElement;
      const dialogContainer = host.closest('mat-dialog-container');
      if (dialogContainer) dialogContainer.scrollTop = 0;
      const childContainer = host.querySelector('.child-container');
      if (childContainer) (childContainer as HTMLElement).scrollTop = 0;
    }, 300);
  }

  /**
   * @description setPhoneNumber function validates phone number and apply masking on the number.
   */

  setPhoneNumber(): void {
    this.helperService
      .validatePhoneFormat(this.formInstance?.phone?.value)
      .subscribe(
        ({
          phoneNumber,
          region,
          code,
        }: {
          phoneNumber: string;
          region: string;
          code: string;
        }) => {
          this.formInstance.phone.setValue(
            code + this.phoneNumberFormat.transform(phoneNumber, code)
          );
        },
        (err: string) => {
          if (window.__dev__) console.log('validatePhoneFormat', err);
          this.notificationService?.showError(err);
          this.formInstance?.phone?.setValue('');
        }
      );
  }

  /**
   * @description getPhysicalCredential function will call the getUserCardsList API
   * @returns void
   */
  getPhysicalCredential(): void {
    this.accountSettingService
      .getUserCardsList(this.userId, this.siteId)
      .subscribe({
        next: (res: any) => {
          if (res) {
            this.userCredentials = res;
            this.userCredentials.filter((card: any) => {
              if (card.cardStatus == ACTIVE) {
                this.isUserCardActive = true;
              }
            });
          } else {
            this.isUserCardActive = false;
          }
        },
        error: (err: Error) => {
          this.isUserCardActive = false;
        },
      });
  }

  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    if (!this.ownProfile) {
      const dashboadUserUrl = this.router.url?.includes(
        CONSTANTS.USER_DASHBOARD
      );
      if (this.userNotHaveExistingGroup && dashboadUserUrl) {
        const criteria: ICriteria = {
          size: 10000,
          searchText: '',
          userGroupId: this.userGroupId,
        };
        this.userListsubscription = this.userManagementService
          .getDashboardUsers(criteria)
          .subscribe({
            next: (response) => {
              // Handle successful API response if needed
              // For example:
              // console.log('API response:', response);
            },
            error: (error) => {
              // Handle API error if needed
              // For example:
              // console.error('API error:', error);
            },
            complete: () => {
              // Close the dialog after API call completes
              this.dialogRef?.close();
              this.router.navigate([
                '/dashboard/users/',
                Utility.encodeToBase64(this.groupTypeName),
                Utility.encodeToBase64(this.userGroupId),
              ]);
            },
          });
        return;
      }
      this.dialogRef?.close();
    } else if (this.ownProfile) {
      const dashboardUrl = this.router.url?.includes(CONSTANTS.DASHBOARD_URL);
      const dashboadUserUrl = this.router.url?.includes(
        CONSTANTS.USER_DASHBOARD
      );
      if (this.userNotHaveExistingGroup && dashboardUrl && dashboadUserUrl) {
        const criteria: ICriteria = {
          size: 10000,
          searchText: '',
          userGroupId: this.userGroupId,
        };
        this.userListsubscription = this.userManagementService
          .getDashboardUsers(criteria)
          .subscribe({
            next: (response) => {
              // Handle successful API response if needed
              // For example:
              // console.log('API response:', response);
            },
            error: (error) => {
              // Handle API error if needed
              // For example:
              // console.error('API error:', error);
            },
            complete: () => {
              // Close the dialog after API call completes
              this.dialogRef?.close();
            },
          });

        return;
      } else if (
        this.userNotHaveExistingGroup &&
        dashboardUrl &&
        !dashboadUserUrl
      ) {
        this.dashboardUserListSubscription = this.dashboardManagementService
          .getDashboardStatistics(this.siteId)
          .subscribe({
            next: (response) => {
              // Handle successful API response if needed
              // For example:
              // console.log('API response:', response);
            },
            error: (error) => {
              // Handle API error if needed
              // For example:
              // console.error('API error:', error);
            },
            complete: () => {
              // Close the dialog after API call completes
              this.dialogRef?.close();
              this.router.navigate(['/dashboard']);
              // this.router
              // .navigateByUrl('/', { skipLocationChange: true })
              // .then(() => {
              //   if (window.__dev__) this.router.navigateByUrl(this.router.url);
              // });
            },
          });
        return;
      }
      this.dialogRef?.close();
    }
  }
  navigateToResendInvitation(): void {
    this.stepperChange.emit((this.stepper = 11));
  }

  navigateToEditPhone(): void {
    this.stepperChange.emit((this.stepper = 15));
  }

  navigateToPendingDeletion(): void {
    this.stepperChange.emit((this.stepper = 13));
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange.emit((this.stepper += -1));
  }

  /**
   * @description validate form if form hold valid value into main form and redirect to next step
   * @returns void
   */
  submit(): void {
    this.submited = true;
    if (this.formGroup?.invalid) return;
  }

  /**
   * @description this will redirect to user access
   * @returns void
   */
  navigateToUserAccess(): void {
    this.stepperChange.emit((this.stepper = 2));
  }

  /**
   * @description this will redirect to user access
   * @returns void
   */
  navigateToUserActivity(): void {
    this.stepperChange.emit((this.stepper = 6));
  }

  /**
   * @description this will redirect to user groups
   * @returns void
   */
  navigateToUserGroups(): void {
    if (this.commonAccessControl) {
      this.stepperChange.emit((this.stepper = 3));
    } else {
      this.stepperChange.emit((this.stepper = 10));
    }
  }

  /**
   * @description #navigateToPhysicalCredentials will redirect to Physical Credentials
   * @returns void
   */
  navigateToPhysicalCredentials(): void {
    this.stepperChange.emit((this.stepper = 5));
  }

  /**
   * @description Active Inactive changeMobileCredentials
   * @param status MatSlideToggleChange object  {source: MatSlideToggle, checked: true}
   * @returns void
   */
  changeMobileCredentials(matSlide: {
    source: MatSlideToggle | undefined;
    checked: boolean | undefined;
  }): void {
    this.mobileCredentialClicked.next(matSlide?.checked); // trigger button click after debounce
  }
  /**
   * @description Active Inactive changeCardCredentials
   * @param status MatSlideToggleChange object  {source: MatSlideToggle, checked: true}
   * @returns void
   */
  changeCardCredentials(matSlide: {
    source: MatSlideToggle | undefined;
    checked: boolean | undefined;
  }): void {
    this.cardCredentialClicked.next(matSlide?.checked); // trigger button click after debounce
  }

  updateMobileCardCredentials(
    mobileCredential: boolean,
    cardCredential: boolean
  ) {
    // The actual action that should be performed on click
    this.accountSettingService
      .updateUserCredentials(mobileCredential)
      .subscribe({
        next: () => {
          this.notificationService.showSuccess(
            this.translate.instant('SUCCESSFULLY_UPDATED')
          );
        },
        error: (err: Error) => {
          if (window.__dev__) console.log('updateMobileCardCredential', err);
          this.notificationService.showError(err?.message);
        },
      });
  }

  removeUser() {
    const dialogInstance = this.helperService.openModalDialog(
      PhysicalCredentialRemovedComponent,
      {
        userDetail: {
          title: this.translate.instant('USER_PROFILE'),
          userName: `${this.profileDetails?.firstName} ${this.profileDetails?.lastName}`,
          isCardActive: this.isUserCardActive,
          userId: this.userId,
          siteId: this.siteId,
        },
        enableBackOperation: false,
        stepper: this.isUserCardActive ? 1 : 0,
      },
      CONSTANTS.FIXED_SCREEN_MODAL
    );
    dialogInstance
      .afterClosed()
      .pipe(
        switchMap((res: any) => {
          const currentUrl = this.router.url;
          this.flowTypeChange.emit((this.flowType = CONSTANTS.REMOVE_USER));
          this.dialogRef?.close(this.flowType);
          if (currentUrl?.includes(CONSTANTS.USER_DASHBOARD)) {
            const criteria: ICriteria = {
              size: 10000,
              searchText: '',
              userGroupId: this.userGroupId,
            };
            this.router.navigate([
              CONSTANTS.USER_DASHBOARD,
              Utility.encodeToBase64(this.groupTypeName),
              Utility.encodeToBase64(this.userGroupId),
            ]);

            return this.userManagementService.getDashboardUsers(criteria);
          } else if (currentUrl?.includes(CONSTANTS.USERS)) {
            this.router.navigate(['/users']);
            return this.filterUserParam
              ? this.userManagementService.getUsersBySite(
                  this.siteId,
                  this.searchedWord,
                  CONSTANTS.GET_USERS_BY_SITES_OPERATION_VIEW,
                  false,
                  this.pageSize,
                  false,
                  this.filterUserParam,
                  undefined,
                  true
                )
              : this.userManagementService.getAllUsers(
                  this.siteId!,
                  CONSTANTS.GET_USERS_BY_SITES_OPERATION_VIEW,
                  this.pageSize,
                  undefined,
                  false,
                  true,
                  false,
                  this.searchedWord
                ); // get updated list from server and update redux state in user-list
          }
          return of();
        })
      )
      .subscribe((result: boolean) => {
        if (result) {
          this.router.navigate(['/users']);
          this.dialogRef?.close();
          this.userManagementService.scrollToTop();
          this.userManagementService
            .getAllUsers(
              this.siteId!,
              CONSTANTS.GET_USERS_BY_SITES_OPERATION_VIEW,
              this.pageSize,
              undefined,
              false,
              true
            )
            .subscribe(); // get updated list from server and update redux state in user-list
        }
      });
  }
  /**
   * @description this method will check the expiry time with current UTC on the bases of key returning from the server
   * @returns access
   */
  private expiryCheckWithCurrentUTC(
    accessDetail: IAccessDetail[]
  ): IAccessDetail[] {
    return accessDetail?.filter(
      (access) => access.isExpired === false || access.isExpired === null
    );
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.userListsubscription?.unsubscribe();
    this.dashboardUserListSubscription?.unsubscribe();
  }
}
